import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { auth, firestore } from '../firebaseConfig';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

function SignupSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleSuccess = async () => {
      try {
        const sessionId = searchParams.get('session_id');
        if (!sessionId) throw new Error('No session ID found');

        const pendingSignupString = localStorage.getItem('pendingSignup');
        if (!pendingSignupString) throw new Error('No pending signup data found');

        const { email, password, fullName, selectedPlan } = JSON.parse(pendingSignupString);

        // Create Firebase user
        const userCred = await createUserWithEmailAndPassword(auth, email, password);

        // Set display name
        await updateProfile(userCred.user, {
          displayName: fullName
        });

        // Create Firestore document
        await setDoc(doc(firestore, 'users', userCred.user.uid), {
          fullName,
          email,
          subscription: selectedPlan,
          createdAt: new Date().toISOString(),
          stripeSessionId: sessionId,
          emailVerified: true // Set this to true to skip verification
        });

        localStorage.removeItem('pendingSignup');
        navigate('/dashboard');
      } catch (err) {
        console.error('Error on success page:', err);
        setError(err.message);
        setTimeout(() => navigate('/signup'), 3000);
      } finally {
        setLoading(false);
      }
    };

    handleSuccess();
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-500 mb-4">{error}</p>
          <p>Omdirigere til oprettelse...</p>
        </div>
      </div>
    );
  }

  return loading ? (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
        <p className="mt-4 text-lg">Opretter din konto...</p>
      </div>
    </div>
  ) : null;
}

export default SignupSuccess;